import { useAuth } from '../context/AuthContext'
import { useSubscription } from '../hooks/useSubscription'
import { t, tEn } from '../i18n/translations'

export default function UserMenu() {
  const { user, loading, login, logout } = useAuth()
  const { isPremium, startCheckout, manageSubscription } = useSubscription()

  if (loading) return null

  if (!user) {
    return (
      <button className="sign-in-btn" onClick={login} title={tEn('signIn')}>
        {t('signIn')}
      </button>
    )
  }

  return (
    <div className="user-menu">
      {user.photoURL && (
        <img className="user-avatar" src={user.photoURL} alt="" referrerPolicy="no-referrer" />
      )}
      {isPremium ? (
        <button className="manage-btn" onClick={manageSubscription} title={tEn('manage')}>
          {t('manage')}
        </button>
      ) : (
        <button className="upgrade-btn" onClick={startCheckout} title={tEn('upgrade')}>
          {t('upgrade')}
        </button>
      )}
      <button className="logout-btn" onClick={logout} title={tEn('signOut')}>
        {t('signOut')}
      </button>
    </div>
  )
}
